/* FIELD */
export const allTagsField = {
    read(_, { readField }) {
        const sections = readField('sections');
        const allTags = sections.map((section) => ({ ...section.items }));
        return allTags;
    },
};
